import {
    REGISTER_CART,
    SET_EBONS,
    REQUEST_EBONS_PARTNER,
    RECEIVE_EBONS_PARTNER,
    FAILURE_EBONS_PARTNER,
    REQUEST_LOCK_EBONS,
    RECEIVE_LOCK_EBONS,
    FAILURE_LOCK_EBONS,
    REQUEST_CREATE_ORDER,
    RECEIVE_CREATE_ORDER,
    FAILURE_CREATE_ORDER,
    REQUEST_EBONS_FAQ,
    RECEIVE_EBONS_FAQ,
    FAILURE_EBONS_FAQ,
    REQUEST_PARTNERS_EBON,
    RECEIVE_PARTNERS_EBON,
    FAILURE_PARTNERS_EBON,
    REQUEST_EBONS_ORDER,
    RECEIVE_EBONS_ORDER,
    FAILURE_EBONS_ORDER,
    RESET_LOCK,
    RESET_CART,
    RESET_ORDER,
    REQUEST_EBONS_SEO,
    RECEIVE_EBONS_SEO,
    FAILURE_EBONS_SEO
} from './constants';

import { CALL_API } from '../../middlewares/api';
import { makeActionCreator } from '../../utils/actionsUtils';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

export const registerCart = cart => {
    return {
        type: REGISTER_CART,
        payload: cart
    };
};

export const setEbons = ebons => {
    return {
        type: SET_EBONS,
        payload: ebons
    };
};

export const fetcheBonsByPartnerId = partnerId => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/partner/availability?partnerId=' + partnerId + '&withInactive=' + true,
            types: [REQUEST_EBONS_PARTNER, RECEIVE_EBONS_PARTNER, FAILURE_EBONS_PARTNER]
        }
    };
};

export const fetchEbonPartners = () => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/partner',
            types: [REQUEST_PARTNERS_EBON, RECEIVE_PARTNERS_EBON, FAILURE_PARTNERS_EBON]
        }
    };
};

export const fetcheFAQByPartnerId = partnerId => {
    return {
        [CALL_API]: {
            endpoint: '/ebon/faq?partnerId=' + partnerId,
            types: [REQUEST_EBONS_FAQ, RECEIVE_EBONS_FAQ, FAILURE_EBONS_FAQ]
        }
    };
};

export const lockEbons = (cart, phoneNumber) => {
    const urlPhoneNumber = phoneNumber ? phoneNumber.replace('+', '%2B') : null;
    const phoneParam = urlPhoneNumber ? `?phoneNumber=${urlPhoneNumber}` : '';
    return {
        [CALL_API]: {
            endpoint: `/ebon/lockv2${phoneParam}`,
            body: cart,
            types: [REQUEST_LOCK_EBONS, RECEIVE_LOCK_EBONS, FAILURE_LOCK_EBONS],
            method: HTTP_METHOD_POST
        }
    };
};

export const createOrder = (partnerId, phoneNumber, enterpriseCardPaidAmount, fixedFacialValue) => {
    const urlPhoneNumber = phoneNumber ? phoneNumber.replace('+', '%2B') : null;
    let url = `/ebon/order?partnerId=${partnerId}`;
    url = urlPhoneNumber ? url.concat(`&phoneNumber=${urlPhoneNumber}`) : url;
    url = enterpriseCardPaidAmount
        ? url.concat(`&enterpriseCardPaidAmount=${enterpriseCardPaidAmount}`)
        : url;
    url = url.concat(`&fixedFacialValue=${fixedFacialValue}`);
    return {
        [CALL_API]: {
            endpoint: url,
            types: [REQUEST_CREATE_ORDER, RECEIVE_CREATE_ORDER, FAILURE_CREATE_ORDER],
            method: HTTP_METHOD_POST,
            payload: { partnerId }
        }
    };
};

export const fetchEbonOrderByIdWithCode = id => {
    return {
        [CALL_API]: {
            endpoint: `/ebon/order/${id}`,
            types: [REQUEST_EBONS_ORDER, RECEIVE_EBONS_ORDER, FAILURE_EBONS_ORDER],
            shouldCallAPI: () => true,
            authenticated: true
        }
    };
};

export const resetLock = makeActionCreator(RESET_LOCK);

export const resetCart = makeActionCreator(RESET_CART);

export const resetOrder = makeActionCreator(RESET_ORDER);

export const fetchEbonSeoByPartnerId = partnerId => {
    return {
        [CALL_API]: {
            endpoint: `/ebon/seo/${partnerId}`,
            types: [REQUEST_EBONS_SEO, RECEIVE_EBONS_SEO, FAILURE_EBONS_SEO]
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/ebon/actions.js